
const quickscan = {
  quickscan_declined_title: "Helaas voldoet uw project niet aan de eisen voor een donatie.",
  quickscan_declined_back: "Wijzig antwoord",

  quickscan_step_1_title: "Is het project gericht op de regio van Fonds 1818?",
  quickscan_step_1_large_text: "Fonds 1818 steunt alleen projecten die gericht zijn op de inwoners van:",
  quickscan_step_1_text: "Delft, Den Haag, Hillegom, Katwijk, Leiden, Leiderdorp, Leidschendam-Voorburg, Lisse, Midden-Delfland, Noordwijk, Oegstgeest, Pijnacker-Nootdorp, Rijswijk, Teylingen, Voorschoten, Wassenaar, Westland, Zoetermeer, Zoeterwoude.",
  quickscan_step_1_declined_text: "Fonds 1818 steunt alleen projecten die gericht zijn op de Inwoners van de regio.",

  quickscan_step_2_title: "Bent u 16 jaar of ouder?",
  quickscan_step_2_text: "Fonds 1818 doneert alleen aan aanvragers vanaf 16 jaar.",
  quickscan_step_2_declined_text: "Fonds 1818 doneert alleen aan aanvragers boven de 16 jaar.",

  quickscan_step_3_title: "Start uw project over acht weken of later?",
  quickscan_step_3_text: "Fonds 1818 steunt geen projecten die al zijn gestart of binnen nu en acht weken starten. Uitzonderingen vormen crowdfundingprojecten. Deze moeten na minstens tien dagen starten.",
  quickscan_step_3_declined_text: "Fonds 1818 steunt geen projecten die al zijn gestart of binnen nu en acht weken starten. Met uitzondering van crowdfundingprojecten.",
  quickscan_step_3_crowdfunding: "Nee, het gaat om crowdfunding",

  quickscan_step_4_title: "Uw plan voldoet potentieel aan de eisen voor een donatie.",
  quickscan_step_4_text: "Maak hieronder een account aan of log in op uw bestaande account.",
}

export default quickscan;
